/**
 * §2 Bonus —— cjwf-bonus（$100 奖励）
 *
 * 需求来源：提示词 第1次提交（DEV-124229）；原型 L3734-3980。
 *
 * 注意事项：
 * 1. .cjwf-bonus__or 在原型里是**绝对定位居中**压在两张卡之间的（手机端靠 grid gap:52px 让位），
 *    故它是 __cards 的兄弟而非卡片内部元素，位置不能随意挪。
 * 2. 原型 §2 独有一套近似粉 #ff0151（12 处），已在 index.less 迁移时按 D7② 统一为 #ff0051。
 * 3. 活动有时效："Campaign Period: Valid through December 31, 2026"，到期需更新文案（见 D8）。
 */
import React from 'react';
import EmphasisText from './EmphasisText';

export default function Bonus({ data }) {
  if (!data) return null;
  const r = data.reward || {};

  return (
    <section className="cjwf-bonus">
      <span className="cjwf-bonus__particle cjwf-bonus__particle--1" />
      <span className="cjwf-bonus__particle cjwf-bonus__particle--2" />
      <span className="cjwf-bonus__particle cjwf-bonus__particle--3" />

      <div className="cjwf-bonus__container">
        {/* 【句中强调改为词条内嵌 <strong>】强调词现在留在词条句子里（见 index.less 末尾
            「配色承接」段的完整原因与实测数据），故这里直接把 HTML 挂到既有宿主元素上，
            **不额外包任何元素** —— 之前 Hero 就因为多包一层 <span> 改变了 flex item 数量而出过错。
            文案源自本地常量/词库、非用户输入，与本仓 mcpLanding/McpLanding.jsx:871-874 同一范式。
            原 <span class="cjwf-bonus__heading-highlight"> 的渐变文字效果由 CSS 的
            `.cjwf-bonus__heading strong:extend(...)` 承接。 */}
        <h2 className="cjwf-bonus__heading">
          <EmphasisText text={data.heading} />
        </h2>

        <div className="cjwf-bonus__cards">
          {(data.cards || []).map((c, i) => (
            <div
              className={'cjwf-bonus__card ' + (i === 0 ? 'cjwf-bonus__card--left' : 'cjwf-bonus__card--right')}
              key={i}
            >
              {/* 原 <span class="cjwf-bonus__money">（粉色 700 不换行）由
                  `.cjwf-bonus__card-title strong:extend(.cjwf-bonus__money all)` 承接 */}
              <h3 className="cjwf-bonus__card-title">
                <EmphasisText text={c.title} />
              </h3>
              <div className="cjwf-bonus__visual">
                <img className="cjwf-bonus__image" src={c.imageUrl} alt={c.imageAlt} loading="lazy" />
              </div>
            </div>
          ))}

          {/* 【必须放在 .cjwf-bonus__cards 内部】OR 徽标是 `position:absolute; left:50%; top:50%`，
              而 `.cjwf-bonus__cards` 才是 `position:relative` 的那个定位父级。
              放到 __cards 外面（我最初的写法）会让它相对更外层定位 → 跑到两卡中间以外的位置。
              它自带 5px 实心描边 + cjwfBonusOr 的 box-shadow 脉冲（边缘特效），
              手机端靠 __cards 的 gap:52px 让位。aria-hidden 与原型一致（纯视觉分隔）。 */}
          <div className="cjwf-bonus__or" aria-hidden="true">{data.orText}</div>
        </div>

        <div className="cjwf-bonus__reward-card">
          <div className="cjwf-bonus__reward-content">
            <h3 className="cjwf-bonus__reward-title">
              <EmphasisText text={r.title} />
            </h3>
            <p className="cjwf-bonus__reward-text">{r.text}</p>

            <div className="cjwf-bonus__reward-meta">
              {(r.metas || []).map((m, i) => (
                <div className="cjwf-bonus__reward-meta-item" key={i}>
                  <strong>{m.label}</strong>
                  {/* 见文件末尾同款说明：相邻文本节点要合成一个表达式，否则 hydrate 报 Text content did not match */}
                  {' ' + m.text}
                  {m.em && (
                    <span className="cjwf-bonus__reward-meta-highlight">{' ' + m.em}</span>
                  )}
                </div>
              ))}
            </div>

            {/* "View T&C" → 活动条款 PDF，新窗口打开（需求 260818）。
                此前指向 `#worldfirst-terms` 占位锚点，而全页并不存在该 id，点了只会跳回页首。 */}
            <a
              className="cjwf-bonus__reward-link"
              href={r.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {r.linkText}
            </a>
          </div>

          <div className="cjwf-bonus__reward-visual">
            {/* 【必须带 cjwf-bonus__reward-image 类】该类是 `position:absolute; width:75%; height:95%;
                object-fit:cover`，把图**脱出布局流**——reward 卡的高度靠 .cjwf-bonus__reward-visual 的
                min-height:175px 撑。漏了这个类，图会按自然尺寸 410x350 参与布局，把卡片从 190px 顶到 352px
                （260818 与原型比对实测差 +162px）。它同时是 hover 放大（scale 1.02→1.06）的作用对象。 */}
            <img
              className="cjwf-bonus__reward-image"
              src={r.imageUrl}
              alt={r.imageAlt}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
